<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Create Entity</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-text-field
                v-model="entity.Entity_Name"
                label="Name"
                :rules="[v => !!v || 'Please specify a name for the entity']"
                data-vv-name="name"
                hint="Name of the Entity"
                required
                outline
              ></v-text-field>

              <v-select
                v-model="entity.Tags"
                :items="possibleTags"
                attach
                outline
                chips
                label="Tags"
                color="purple"
                multiple
              ></v-select>

              <v-textarea
                name="input-7-1"
                v-model="entity.Search_Query"
                label="Entity Search Query"
                :rules="[v => !!v || 'Please specify a query']"
                required
                hint="Query for filtering relevant results for this entity. Used in Entity Matching e.g."
                outline
              ></v-textarea>

              <v-select
                v-model="entity.Country_Code"
                :items="countryCodes"
                attach
                outline
                chips
                hint="Country to which this entity belongs mainly"
                label="Country Code"
                color="purple"
                multiple
                required
                :rules="[(v) =>  v.length>0 || 'Please provide at least one country code']"
              ></v-select>

            </v-card-text>
         
          </v-card>
          <v-card>          
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Regex Checks</v-toolbar-title>
            </v-toolbar>             
             <v-card-text>
              <v-textarea
                name="input-7-1"
                label="Regex from Entity Search Query"
                v-model="Regex_from_Ubermetrics_search"
                hint="This regex will be used for entity matching in our process"
                outline
                disabled
                readonly
              ></v-textarea>
              <v-textarea
                name="input-7-1"
                label="Pattern Definitions"
                v-model="Pattern_Definitions"
                hint="Hint text"
                outline
                disabled
                readonly
              ></v-textarea>
              <v-textarea
                name="input-7-1"
                label="Regex for Processing"
                v-model="Regex_for_Processing"
                hint="Hint text"
                outline
                disabled
                readonly
              ></v-textarea>
            </v-card-text>       
          </v-card>
                        
          <v-card>
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Validation</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-form
                ref="testinput_form"
              >
                <v-text-field
                  v-model="testInput"
                  label="Test Input Data for Entity Query"
                  hint="Enter some test string to see if the pattern is matching"
                  loading
                >
                  <v-progress-linear
                    slot="progress"
                    :value="progress"
                    :color="testInputColor"
                    height="7"
                  ></v-progress-linear>

                </v-text-field>

              </v-form>

            </v-card-text>

          </v-card>
          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Chinese String Replacement (For Chinese Entities Only!)</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-layout row>
                <v-flex xs6>
                  <v-textarea
                    name="chinese-string"
                    v-model="chineseStringDisplay"
                    label="Chinese String"
                    hint="Chinese characters for search query (comma-separated for multiple values)"
                    outline
                    rows="2"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    name="latin-replacement"
                    v-model="entity.Latin_Replacement"
                    label="Latin Letter Replacement"
                    hint="Latin letters that replace the Chinese string"
                    outline
                    rows="2"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card>

            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Industries / Branchen</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-select
                v-model="entity.Industry_1"
                :items="industries_1"
                attach
                outline
                chips
                clearable
                label="Industry 1 / Branche 1"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industry_2"
                :items="industries_2"
                attach
                outline
                chips
                clearable
                label="Industry 2 / Branche 2"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industry_Final"
                :items="industries_final"
                attach
                outline
                chips
                clearable
                label="Industry Final / Branche Final"
                color="purple"
              ></v-select>

              <v-select
                v-model="entity.Industries_Austria"
                :items="industries_austria"
                attach
                outline
                chips
                label="Industries_Austria"
                color="purple"
                multiple
              ></v-select>

              <v-select
                v-model="entity.Industries_Switzerland"
                :items="industries_switzerland"
                attach
                outline
                chips
                clearable
                label="Industry Switzerland"
                color="purple"
              ></v-select>
                            
            </v-card-text>
          </v-card>
          
          <v-card>
          <div
          v-for="(input, index) in entity.Kununu_Links"
          :key="`kununuInput-${index}`"
          class="input wrapper flex items-center"
          >
          <v-card-text>
            <!--          Remove Svg Icon-->
            <svg
              v-show="entity.Kununu_Links.length > 0"
              @click="removeField(index, entity.Kununu_Links)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="#EC4899"
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
            />
            </svg>        
            <v-text-field
                v-model="entity.Kununu_Links[index]"
                label="Kununu-Link"
                hint="a kununu link"
                outline/>
          </v-card-text>          
          </div>
          <v-card-text>
            <v-btn @click="addField(input, entity.Kununu_Links)" large>+ Add Kununu Link</v-btn>
          </v-card-text>                      
          </v-card>   

          <v-card>
          <div
          v-for="(input, index) in entity.Twitter_Authors"
          :key="`twitterInput-${index}`"
          class="input wrapper flex items-center"
          >
          <v-card-text>
            <!--          Remove Svg Icon-->
            <svg
              v-show="entity.Twitter_Authors.length > 0"
              @click="removeField(index, entity.Twitter_Authors)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              class="ml-2 cursor-pointer"
            >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="#EC4899"
              d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
            />
            </svg>        
            <v-text-field
                v-model="entity.Twitter_Authors[index]"
                label="Twitter-Author"
                hint="a twitter author"
                outline/>
          </v-card-text>          
          </div>
          <v-card-text>
            <v-btn @click="addField(input, entity.Twitter_Authors)" large>+ Add Twitter Author</v-btn>
          </v-card-text>                      
          </v-card>   
                              
          <v-card>
            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Fulltext Search</v-toolbar-title>
            </v-toolbar>
            <v-card-text>



              <v-autocomplete
                v-model="ubermetricsSearchSelect"
                :items="ubermetricsSearches"
                :search-input.sync="search"
                :required="!entity.Searchname"
                :rules="[v => (!!v || !!entity.Searchname) || 'Please specify a either a new search name or pick an existing search']"
                :readonly="entity.Searchname.length>0"
                :disabled="entity.Searchname.length>0"
                outline
                cache-items
                hide-no-data
                no-filter
                item-text="Detail_Info"
                item-value="Unique_Id"
                label="Existing Fulltext Searches"
                placeholder="Start typing to Search"
              ></v-autocomplete>

              <v-text-field
                name="input-7-1"
                label="Name for new Fulltext Search"
                v-model="entity.Searchname"
                :required="!ubermetricsSearchSelect"
                :rules="[v => (!!v || !!ubermetricsSearchSelect) || 'Please specify a either a new search name or pick an existing search']"                
                :readonly="ubermetricsSearchSelect"
                :disabled="ubermetricsSearchSelect"                
                outline
              ></v-text-field>
              
              <v-textarea
                name="input-7-1"
                v-model="entity.Ubermetrics_Search_Query"
                label="Fulltext Search Query (for new searches)"
                hint="Search Query for Fulltext. If empty the Entity Search Query is used."
                :readonly="(ubermetricsSearchSelect||!entity.Searchname)"
                :disabled="(ubermetricsSearchSelect||!entity.Searchname)"
                outline
              ></v-textarea>


              <v-text-field
                name="input-7-1"
                v-model="entity.Author_Query"
                label="Author Query"
                hint="Query to filter results for the given author"
                :readonly="(ubermetricsSearchSelect||!entity.Searchname)"
                :disabled="(ubermetricsSearchSelect||!entity.Searchname)"
                outline
              ></v-text-field>
              
              <v-select
                v-model="entity.language_code"
                :items="languageCodes"
                attach
                :readonly="(ubermetricsSearchSelect||!entity.Searchname)"
                :disabled="(ubermetricsSearchSelect||!entity.Searchname)"       
                outline
                chips
                hint="Based on this language code the ubermetrics language will be set"                
                label="Language Code"
                color="purple"
                multiple
                required
                :rules="[(v) =>  (v.length>0  || !!ubermetricsSearchSelect) || 'Please provide at least one language code']"
              ></v-select>   

              <v-select
                v-model="entity.datasource"
                :items="dataSources"
                attach
                :readonly="(ubermetricsSearchSelect||!entity.Searchname)"
                :disabled="(ubermetricsSearchSelect||!entity.Searchname)"       
                outline
                chips
                hint="This is the fulltext data that should be used"                
                label="Datasource"
                color="purple"
              ></v-select> 

              <v-textarea
                label="Regex from Fulltext Search"
                v-model="Regex_from_Fulltext_search"
                rows="1"
                outline
                auto-grow
                readonly
              ></v-textarea> 
              <v-btn @click="validateQuery"
                     color="green darken-1"
                     class="white--text"
                     large>
                Validate with Athena
                <v-icon right dark>verified_user</v-icon>
              </v-btn>
 
              <v-switch
                v-model="entity.backward_search"
                :label="`BACKWARD SEARCH`"
              ></v-switch>                          
          </v-card-text>

          </v-card>
          <v-card>
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Validation</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-form
                ref="testinput_form"
              >
                <v-text-field
                  v-model="testInputFulltext"
                  label="Test Input Data for Fulltext Query"
                  hint="Enter some test string to see if the pattern is matching"
                  loading
                >
                  <v-progress-linear
                    slot="progress"
                    :value="progress"
                    :color="testInputColorFt"
                    height="7"
                  ></v-progress-linear>

                </v-text-field>

              </v-form>
              
              <v-btn @click="submit" color="error">Save and Update</v-btn>
              <v-btn @click="cancel">Cancel</v-btn>   
            </v-card-text>


            <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :timeout="6000"
              :top="true"
              :vertical="true"
            >
              {{ text }}
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>

          </v-card> 
       
        </v-form>
      </v-container>
    </v-layout>
    <v-dialog v-model="validate_dialog" max-width="800px">
  <v-card>
    <v-card-title class="headline">Query Validation</v-card-title>
    <v-card-text>
      <div v-if="validatedFragments.length">
        <v-list>
          <template v-for="(msg, index) in validatedFragments">
            <v-list-item :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ msg }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < validatedFragments.length - 1"></v-divider>
          </template>
        </v-list>
      </div>
      <div v-else>No validation messages (yet).</div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="validate_dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import Config from '../utils/Config'
import _ from 'underscore'
import AmplifyStore from '../store/store'

export default {
  data() {
    return {
      valid: true,
      validTestInput: false,
      validate_dialog: false,
      validatedFragments: [],
      testInput: '',   
      validTestInputFulltext: false,
      testInputFulltext: '',             
      entity: {
        Entity_Name: '',
        Tags: [],
        Search_Query: '',
        Chinese_String: [],
        Latin_Replacement: '',
        Ubermetrics_Search_Query: null,
        Searchname: '',
        Ubermetrics_Account_Id: null,
        Ubermetrics_Search_Id: null,
        Industry_1: null,
        Industry_2: null,
        Industry_Final: null,
        Industries_Austria: [],     
        Industries_Switzerland: null,   
        Country_Code: ['DE'],
        country_code_search: '',
        Kununu_Links: [],
        Twitter_Authors:[],
        backward_search: true
      },
      text: '',
      snackbar: false,
      search: null,
      ubermetricsSearchSelect: null,
      ubermetricsSearches: [],
      Regex_for_Processing: null,
      Regex_from_Ubermetrics_search: null,
      Pattern_Definitions: null,
      possibleTags: Config.ENTITY_TAGS,
      industries_1: Config.INDUSTRIES_1,
      industries_2: Config.INDUSTRIES_2,
      industries_final: Config.INDUSTRIES_FINAL,
      industries_austria: Config.INDUSTRIES_AUSTRIA, 
      industries_switzerland: Config.INDUSTRIES_SWITZERLAND.sort(),       
      countryCodes: Config.COUNTRY_CODES_ENTITIES.sort(),
      languageCodes: Config.LANGUAGE_CODES,
      dataSources: Config.DATASOURCES,
      Regex_from_Fulltext_search: null,
      regexDict: {
        fulltextquery: '',
        event_type: '',
        used_table: 'fulltext',
    },
      Update_Note: ''      
    }
  },
  mounted() {
    const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
    axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
    this.$emit('TriggerLoading', false)
  },
  watch: {
    Regex_from_Fulltext_search(newVal) {
      this.regexDict.fulltextquery = newVal;
    },

    search(query) {
      if (query && (!this.ubermetricsSearchSelect || this.ubermetricsSearchSelect.text !== query)) {
        this.querySearch(query)
      }
    },
    'testInput': function (newValue, oldValue) {
      clearTimeout(this.validatationTimeout);

      this.validatationTimeout = setTimeout(() => {
        let payload = {
          Search_in_Ubermetrics: this.entity.Search_Query,
          test_input: this.testInput,
        };
        this.validTestInput = false;
        this.$emit('TriggerLoading', true);      
        let base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64');
        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Payload,helpertype:'run_regex'}).then(response => {    
          this.validTestInput = response.data.Match_available;
          this.$emit('TriggerLoading', false);                    
        }).catch(error => {
          console.log(error);
          this.text = error;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);     
        });
      }, 1000);
    },    
    'testInputFulltext': function (newValue, oldValue) {
      clearTimeout(this.validatationTimeout);

      this.validatationTimeout = setTimeout(() => {
        let payload = {
          Search_in_Ubermetrics: this.entity.Ubermetrics_Search_Query,
          test_input: this.testInputFulltext,
        };
        this.validTestInputFulltext = false;
        this.$emit('TriggerLoading', true);      
        let base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64');

        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Payload,helpertype:'run_regex_fulltext'}).then(response => {
          this.validTestInputFulltext = response.data.Match_available;
          this.$emit('TriggerLoading', false);                    
        }).catch(error => {
          console.log(error);
          this.text = error;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);     
        });
      }, 1000);
    },        
    'entity.Search_Query': _.debounce(
      function (newValue, oldValue) {

        let base64Search = Buffer.from(newValue)
          .toString('base64')
        axios
          .post(`${Config.REGEX_API_URL}/helper`,{query: base64Search,helpertype:'searchformat'})
          .then(response => {
            this.Regex_for_Processing = response.data.Regex_for_Processing
            this.Regex_from_Ubermetrics_search = response.data.Regex_from_Ubermetrics_search
            this.Pattern_Definitions = response.data.Pattern_Definitions
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
      },
      500,
    ),
    'entity.Ubermetrics_Search_Query': _.debounce(
      function (newValue, oldValue) {

        let base64Search = Buffer.from(newValue).toString('base64');
        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Search,helpertype:'searchformatfulltext'}).then(response => {        
          this.Regex_from_Fulltext_search = response.data.Regex_from_Fulltext_search;
        }).catch(error => {
          console.log(error);
          this.errored = true;
        });
      },
      500,
    ),      
  },
  computed: {
    progress() {
      return (this.validTestInput ? 100 : 100);
    },
    testInputColor() {
      return (this.validTestInput ? 'success' : 'error');
    },
    progress() {
      return (this.validTestInputFulltext ? 100 : 100);
    },
    testInputColorFt() {
      return (this.validTestInputFulltext ? 'success' : 'error');
    },
    chineseStringDisplay: {
      get() {
        return Array.isArray(this.entity.Chinese_String) ? this.entity.Chinese_String.join(', ') : '';
      },
      set(value) {
        this.entity.Chinese_String = value ? value.split(',').map(s => s.trim()).filter(s => s.length > 0) : [];
      }
    },
    ubermetricsAccount() {

      if (this.entity.Account_Search_Ids_New.length === 0) {
        return null;
      }

      return "not null";
    },
  },  
  methods: {
    querySearch: _.debounce(
      function querySearch(query) {

        this.$emit('TriggerLoading', true)

        axios
          .get(`${Config.API_URL}/ubermetrics-searches?query=${query}`)
          .then(response => {
            this.ubermetricsSearches = _.map(response.data, function (umsearch) {
              return _.extend(
                {
                  Detail_Info: `${umsearch.Name} (Account/Search: ${umsearch.Account_Id}/${umsearch.Search_Id}, Active: ${umsearch.Ubermetrics_Search_Status}, Type: ${umsearch.Search_Type})`,
                },
                umsearch)
            })
            this.$emit('TriggerLoading', false)
          })
          .catch(error => {
            console.error(error)
            this.errored = true
          })
      },
      500,
    ),
    'cancel': function () {
      this.$router.go(-1)
    },
     addField(value, fieldType) {
      fieldType.push("");
      },
     removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
    'submit': function () {

      if (this.$refs.form.validate()) {

        if (this.ubermetricsSearchSelect != null) {
          const umAccountParts = this.ubermetricsSearchSelect.split('_')
          this.entity.Ubermetrics_Account_Id = umAccountParts[0]
          this.entity.Ubermetrics_Search_Id = umAccountParts[1]
        }

        this.$emit('TriggerLoading', true)

        axios
          .post(`${Config.API_URL}/entity`, this.entity)
          .then(response => {
            console.info(response.data)
            this.text = response.data.message
            this.snackbar = true
            this.$emit('TriggerLoading', false)
          })
          .catch(error => {
            console.error(error)
            this.text = error
            this.snackbar = true
            this.$emit('TriggerLoading', false)
          })
      }

    },
    'validateQuery': function () {
    this.$emit('TriggerLoading', true);

    let postData;

    if (
      this.entity.language_code.length > 0
    ) {
      postData = this.$data.regexDict.fulltextquery +
        '_separator___value_' +
        this.entity.language_code[0].toLowerCase() +
        '_separator___value_' +
        this.$data.regexDict.used_table;

    } else {
      postData = this.$data.regexDict.fulltextquery +
        '_separator___value_de_separator___value_' +
        this.$data.regexDict.used_table;

      // Posting with default (german) language 'de'
    }

    axios.post(`${Config.API_URL}/event_regex/validate`, postData)
      .then(response => {
        console.info('Response from validate:', response);
        this.validatedFragments = response.data.fragments;
        console.log(this.validatedFragments);
        this.validate_dialog = true;
        this.$emit('TriggerLoading', false);
      })
      .catch(error => {
        this.text = `${error.response.data.message || 'Unknown error'} (${error})`;
        this.snackbar = true;
        this.$emit('TriggerLoading', false);
      });
  }
  },
}
</script>
